import {
  DOWNLOAD_STATUS_DISPLAY,
  FUT_RESULT_DISPLAY,
  IR_RESULT_DISPLAY,
  REVIEW_STATUS_DISPLAY,
  WORKLIST_STATUSES_DISPLAY,
} from '../constants';
import { objectToArray } from '@/helpers';
import CustomDateRange from '@/new-components/CustomDateRange';
import CustomSelectContainer from '@/new-components/CustomSelectOld/CustomSelectContainer';
import { Box, Toolbar, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { isBoolean, isEmpty } from 'lodash';
import moment from 'moment';
import React, { useMemo } from 'react';

const CustomButton = withStyles({
  label: {
    fontWeight: 600,
  },
})(Button);

const GroupToolbar = ({
  filterOption,
  setFilterOption,

  onFilterOptionChange,
  onResetFilterOps,

  appointmentDate,
  setAppointmentDate,
}) => {
  const renderValue = (array, label, defaultLabel) => {
    let value = '';
    if (!array || array?.length === 0) value = defaultLabel;
    else if (array?.length === 1) value = array[0];
    else value = `${label} (${array?.length})`;

    return value;
  };

  const renderDateValue = (array, defaultLabel) => {
    /* 
    1. !startDate && !endDate => defaultLabel
    2. startDate && !endDate => startDate format: DD/MM/YYYY
    3. startDate && endDate
      - if startDate and endDate in the same month, year => format(DD-DD/MM/YYYY)
      - else format(DD/MM/YYYY-DD/MM/YYYY)
    */

    if (isEmpty(array)) return defaultLabel;
    const startDate = moment(array[0]).format('DD/MM/YYYY');
    const endDate = moment(array[1]).format('DD/MM/YYYY');

    if (startDate.trim() === endDate.trim()) {
      return `${startDate} `;
    } else if (moment(array[0]).isSame(moment(array[1]), 'year')) {
      const newStartDate = moment(array[0]).format('DD/MM');
      return `${newStartDate} - ${endDate} `;
    }

    return `${startDate} - ${endDate} `;
  };

  const isEmptyFilterParams = useMemo(() => {
    const filterKeys = Object.keys(filterOption);
    return filterKeys.every((key) =>
      isBoolean(filterOption[key])
        ? !filterOption[key]
        : isEmpty(filterOption[key])
    );
  }, [filterOption]);

  return (
    <Toolbar>
      <Box
        display="flex"
        flex={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" gridGap={12}>
          <CustomDateRange
            selectedDate={appointmentDate || []}
            renderValue={() =>
              renderDateValue(appointmentDate || [], 'Select appointment date')
            }
            onChange={(startDate, endDate) => {
              if (startDate && endDate) {
                setAppointmentDate([startDate, endDate]);
                setFilterOption({
                  ...filterOption,
                  fromDate: startDate.toISOString(),
                  toDate: endDate.toISOString(),
                });
              } else {
                setAppointmentDate([]);
                setFilterOption({
                  ...filterOption,
                  fromDate: null,
                  toDate: null,
                });
              }
            }}
          />

          <CustomSelectContainer
            isFullWidth
            filterValue={filterOption?.resultTypes || []}
            data={objectToArray(IR_RESULT_DISPLAY) || []}
            renderValue={renderValue(
              filterOption?.resultTypes?.map(
                (it) =>
                  objectToArray(IR_RESULT_DISPLAY).find(
                    (item) => item.key === it
                  ).value
              ),
              'Results',
              'All IR results'
            )}
            clearable={false}
            onChange={onFilterOptionChange('resultTypes')}
            labelSelectAll={'All IR results'}
            useSelectAll
            checkedAll={
              objectToArray(IR_RESULT_DISPLAY)?.length ===
              filterOption?.resultTypes?.length
            }
          />

          <CustomSelectContainer
            isFullWidth
            filterValue={filterOption?.downloadStatuses || []}
            data={objectToArray(DOWNLOAD_STATUS_DISPLAY) || []}
            renderValue={renderValue(
              filterOption?.downloadStatuses?.map(
                (it) =>
                  objectToArray(DOWNLOAD_STATUS_DISPLAY).find(
                    (item) => item.key === it
                  ).value
              ),
              'Download statuses',
              'All Download statuses'
            )}
            clearable={false}
            onChange={onFilterOptionChange('downloadStatuses')}
            labelSelectAll={'All Download statuses'}
            useSelectAll
            checkedAll={
              objectToArray(DOWNLOAD_STATUS_DISPLAY)?.length ===
              filterOption?.downloadStatuses?.length
            }
          />

          <CustomSelectContainer
            isFullWidth
            filterValue={filterOption?.screeningResults || []}
            data={objectToArray(FUT_RESULT_DISPLAY) || []}
            renderValue={renderValue(
              filterOption?.screeningResults?.map(
                (it) =>
                  objectToArray(FUT_RESULT_DISPLAY).find(
                    (item) => item.key === it
                  ).value
              ),
              'FUT Results',
              'All FUT Results'
            )}
            clearable={false}
            onChange={onFilterOptionChange('screeningResults')}
            labelSelectAll={'All FUT Results'}
            useSelectAll
            checkedAll={
              objectToArray(FUT_RESULT_DISPLAY)?.length ===
              filterOption?.screeningResults?.length
            }
          />

          {/* <CustomSelectContainer
            isFullWidth
            filterValue={filterOption?.reviewStatuses || []}
            data={objectToArray(REVIEW_STATUS_DISPLAY) || []}
            renderValue={renderValue(
              filterOption?.reviewStatuses?.map(
                (it) =>
                  objectToArray(REVIEW_STATUS_DISPLAY).find(
                    (item) => item.key === it
                  ).value
              ),
              'Statuses',
              'All review statuses'
            )}
            clearable={false}
            onChange={onFilterOptionChange('reviewStatuses')}
            labelSelectAll={'All review statuses'}
            useSelectAll
            checkedAll={
              objectToArray(REVIEW_STATUS_DISPLAY)?.length ===
              filterOption?.reviewStatuses?.length
            }
          /> */}
          <CustomSelectContainer
            isFullWidth
            filterValue={filterOption?.worklistStatuses || []}
            data={objectToArray(WORKLIST_STATUSES_DISPLAY) || []}
            renderValue={renderValue(
              filterOption?.worklistStatuses?.map(
                (it) =>
                  objectToArray(WORKLIST_STATUSES_DISPLAY).find(
                    (item) => item.key === it
                  ).value
              ),
              'Statuses',
              'All statuses'
            )}
            clearable={false}
            onChange={onFilterOptionChange('worklistStatuses')}
            labelSelectAll={'All statuses'}
            useSelectAll
            checkedAll={
              objectToArray(WORKLIST_STATUSES_DISPLAY)?.length ===
              filterOption?.worklistStatuses?.length
            }
          />
        </Box>

        <CustomButton
          color="primary"
          disabled={isEmptyFilterParams}
          onClick={onResetFilterOps}
        >
          Reset
        </CustomButton>
      </Box>
    </Toolbar>
  );
};

export default GroupToolbar;
